export enum LOCATION_AREA_ENUM {
  AMERICAS = 'Americas',
  EURASIA = 'Eurasia',
}
